module.exports = __webpack_public_path__ + "img/icb-empty-elite-e@2x.42e3d224.png";